import {Injectable} from "@angular/core";
import {Http, Headers, ResponseContentType} from '@angular/http';
import {AppConfig} from "./app.config";
import "rxjs/add/operator/map";
import {Auth} from "./app.auth";
/**
 * Created by maty on 13/02/2017.
 */

@Injectable()
export class HttpClient {
    private _appVersion = "";

    constructor(private _http: Http, private _authService: Auth) {
        this._appVersion = AppConfig.VERSION;
    }

    private defaultHeaders(headers: Headers) {
        headers.append("X-Authorization", this._authService.authToken);
        headers.append("X-ClientVersion", "cms-" + this._appVersion);
        headers.append("X-Language", "en-US");
    }

    get(url: string) {

        let headers = new Headers();
        if(url != "/diamonds.json") {
            this.defaultHeaders(headers);
        }

        return this._http
            .get(AppConfig.API_ROOT + url, {
                headers: headers
            })
            .map(response => {
                console.log(response);
                let decoded = response.json();

                console.log(decoded);
                if ( decoded.error_code != 0 && url != "/diamonds.json") {
                    return {
                        error: decoded.error_code
                    }
                }

                return decoded;
            });
    }

    post(url: string, data: any, isBlob?: boolean) {
        let headers = new Headers();
        this.defaultHeaders(headers);
        let opts = {
            headers: headers
        };
        if (isBlob) {
            opts['responseType'] = ResponseContentType.Blob;
        }
        return this._http
            .post(AppConfig.API_ROOT + url, JSON.stringify(data), opts)
            .map(response => {
                console.log("Response from " + url + ":", 
                {
                    requestFields: data,
                    response: response
                });

                if (isBlob) {
                    return response;
                }

                let decoded = response.json();

                if ( decoded.error_code != 0 ) {
                    return {
                        error: decoded.error_code
                    }
                }

                return decoded;
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/http.client.ts